// SaveForLater.js
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import axiosClient from "../../utils/axiosClient";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import "./save.css";
import Toast from "../Toast";
import { BookMarked } from "lucide-react";

const SaveForLaterButton = ({ item }) => {
  const router = useRouter();
  const [loginData, setLoginData] = useState({});

  useEffect(() => {
    const storedLoginData = JSON.parse(localStorage.getItem("login")) || {};
    setLoginData(storedLoginData);
  }, []);

  const handleLoginSignup = () => {
    const currentPath = router.asPath;
    router.push(`/login?redirect=${encodeURIComponent(currentPath)}`);
  };
  const saveLaterItem = (selectedItem) => {
    if (!loginData || !loginData.user) {
      handleLoginSignup();
      return;
    }

    try {
      const body = {
        id: 0,
        userId: loginData.user.id,
        ItemId: Number(selectedItem.id),
      };
      axiosClient.post("saveSaveLaterInfo", body);
      toast.success("Successfully saved for later");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to save for later. Please try again.");
    }
  };

  return (
    <>
      <Button
        className="btn-blue w-100 btn-block btn-add-to-cart"
        type="button"
        onClick={(e) => {
          e.preventDefault();
          saveLaterItem(item);
        }}
      >
        <BookMarked style={{ margin: 5 }} /> Save for later
      </Button>
      <Toast />
    </>
  );
};

export default SaveForLaterButton;
